import React from 'react';
import { Collapse, Space } from 'antd';
import { FormattedMessage } from 'react-intl';
import css from './FAQsPage.module.css';
import Topbar from '../TopbarContainer/Topbar/Topbar';
import { LayoutSideNavigation, LayoutSingleColumn, Page } from '../../components';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import FooterContainer from '../../containers/FooterContainer/FooterContainer';

const FAQsPage = () => (
  <div>

<Page title={'Home – World like Home'} scrollingDisabled={false}>
      <LayoutSingleColumn
        topbar={
          <TopbarContainer
            mobileRootClassName={css.mobileTopbar}
            desktopClassName={css.desktopTopbar}
          />
        }
        
        footer={<FooterContainer />}
      >
        <div className={css.faqPageContent}>
            <h2 className={css.faqPageTitle}><FormattedMessage id="Footer.faqHead" /></h2>
    <div className={css.faqColumn}>
      <div className={css.faqColumnContent}>
      <Space direction="vertical">
        <Collapse
          collapsible="header"
          defaultActiveKey={['1']}
          items={[
            {
              key: '1',
              label: <FormattedMessage id="Footer.faq1Title" />,
              children: <FormattedMessage id="Footer.faq1Desc"
              values={{
                br: <br />
              }}
            />,
            },
          ]} />
        <Collapse
          collapsible="header"
          defaultActiveKey={['1']}
          items={[
            {
              key: '2',
              label: <FormattedMessage id="Footer.faq2Title" />,
              children: <FormattedMessage id="Footer.faq2Desc"/>,
            },
          ]} />
        <Collapse
          collapsible="header"
          defaultActiveKey={['1']}
          items={[
            {
              key: '3',
              label: <FormattedMessage id="Footer.faq3Title" />,
              children: <FormattedMessage id="Footer.faq3Desc"
              values={{  
                p: msgFragment => <p>{msgFragment}</p>,
                br: <br />
              }}
            />,
            },
          ]} />
        <Collapse
          collapsible="header"
          defaultActiveKey={['1']}
          items={[
            {
              key: '4',
              label: <FormattedMessage id="Footer.faq4Title" />,
              children: <FormattedMessage id="Footer.faq4Desc"
              values={{br: <br />
              }}
              />
            },
          ]} />
        <Collapse
          collapsible="header"
          defaultActiveKey={['1']}
          items={[
            {
              key: '5',
              label: <FormattedMessage id="Footer.faq5Title" />,
              children: <FormattedMessage id="Footer.faq5Desc"
              values={{  
                p: msgFragment => <p>{msgFragment}</p>,
                b: msgFragment => <b>{msgFragment}</b>,
                u: msgFragment => <u>{msgFragment}</u>,
                br: <br />
              }}
              />,
            },
          ]} />
        <Collapse
          collapsible="header"
          defaultActiveKey={['1']}
          items={[
            {
              key: '6',
              label: <FormattedMessage id="Footer.faq6Title" />,
              children: <FormattedMessage id="Footer.faq6Desc"/>,
            },
          ]} />
      </Space>
      </div>
      <div className={css.faqColumnContent}>
      <Space direction="vertical">
        <Collapse
          collapsible="header"
          defaultActiveKey={['1']}
          items={[
            {
              key: '7',
              label: <FormattedMessage id="Footer.faq7Title" />,
              children: <FormattedMessage id="Footer.faq7Desc"
              values={{  
               
                br: <br />
              }}
              /> },
          ]} />
        <Collapse
          collapsible="header"
          defaultActiveKey={['1']}
          items={[
            {
              key: '8',
              label: <FormattedMessage id="Footer.faq8Title" />,
              children: <FormattedMessage id="Footer.faq8Desc"
              values={{br: <br />
              }}
              /> },
          ]} />
        <Collapse
          collapsible="header"
          defaultActiveKey={['1']}
          items={[
            {
              key: '9',
              label: <FormattedMessage id="Footer.faq9Title" />,
              children: <FormattedMessage id="Footer.faq9Desc"
              values={{br: <br />
              }}
              /> },
          ]} />
        <Collapse
          collapsible="header"
          defaultActiveKey={['1']}
          items={[
            {
              key: '10',
              label: <FormattedMessage id="Footer.faq10Title" />,
              children: <FormattedMessage id="Footer.faq10Desc"
              values={{br: <br />
              }}
              /> },
          ]} />
        <Collapse
          collapsible="header"
          defaultActiveKey={['1']}
          items={[
            {
              key: '11',
              label: <FormattedMessage id="Footer.faq11Title" />,
              children: <FormattedMessage id="Footer.faq11Desc"
              values={{br: <br />
              }}
              /> },
          ]} />
        <Collapse
          collapsible="header"
          defaultActiveKey={['1']}
          items={[
            {
              key: '12',
              label: <FormattedMessage id="Footer.faq12Title" />,
              children: <FormattedMessage id="Footer.faq12Desc"
              values={{br: <br />
              }}
              /> },
          ]} />
        <Collapse
          collapsible="header"
          defaultActiveKey={['1']}
          items={[
            {
              key: '13',
              label: <FormattedMessage id="Footer.faq13Title" />,
              children: <FormattedMessage id="Footer.faq13Desc"
              values={{br: <br />
              }}
              /> },
          ]} />
      </Space>
      </div>
    </div>
    </div>
        </LayoutSingleColumn>
        </Page>

  </div>
);
export default FAQsPage;